




import { defineComponent, useRoute } from '@nuxtjs/composition-api';
import { DcwSuccessStoryLayout } from '@/components/Layouts';
import { useLocales, usePage } from '@/composables';
import {
  PagesLinks,
  ProjectSelectors,
  isStoryContent,
  SuccessStoriesLayoutContent,
  StoryBannerContent,
  StoryBodyContent,
  PageInfoProps,
  HeaderColors
} from '@/types';
import { getDescription } from '@/helpers';
import { successStoriesService as service } from '@/service/model';

export default defineComponent({
  components: { DcwSuccessStoryLayout },
  layout: 'Default',
  setup() {
    const route = useRoute();
    const { translation } = useLocales();
    const successStory = service.getContentById(route.value.params.id);

    const othersStories = service.getOtherContent(route.value.params.id).map((item) => ({
      id: item.id,
      img: item.images.slider,
      name: item.name,
      position: item.position,
      description: item.shortStory,
      button: {
        text: translation.buttons.readSuccessStory,
        href: `${PagesLinks.SUCCESS_STORIES}/${item.id}`
      },
      isLink: true
    }));

    const textContent = successStory.questionsAndAnswers
      .filter(isStoryContent)
      .flatMap((el) => [el.title, el.answer])
      .join(' ');

    const pageTitle = `${translation.pagesNames.successStory}: ${successStory.name}`;

    usePage({
      data: {
        title: pageTitle,
        description: getDescription(successStory.details),
        ogCover: successStory.images.og
      },
      headerColor: HeaderColors.WHITE,
      mobileHeaderColor: HeaderColors.DARK,
      breadcrumbs: [
        { name: translation.pagesNames.home, url: PagesLinks.HOME },
        { name: translation.pagesNames.career, url: PagesLinks.CAREER },
        { name: translation.pagesNames.successStories, url: PagesLinks.SUCCESS_STORIES },
        { name: pageTitle, url: '' }
      ]
    });

    const banner: StoryBannerContent = {
      name: successStory.name,
      position: successStory.position,
      description: successStory.details,
      cover: successStory.images.cover,
      avatar: successStory.images.avatar
    };

    const body: StoryBodyContent = {
      body: successStory.questionsAndAnswers,
      avatar: successStory.images.avatar
    };

    const otherStoriesContent = {
      ...translation.ui.othersStories,
      people: othersStories
    };

    const pageInfo: PageInfoProps = {
      contentWrapperClass: ProjectSelectors.Q_AND_A_SECTION_WRAPPER,
      text: textContent,
      badges: [{ name: 'Success Stories', link: PagesLinks.SUCCESS_STORIES }],
      details: [successStory.name, successStory.info.date]
    };

    const layoutContent: SuccessStoriesLayoutContent = {
      banner,
      body,
      otherStories: otherStoriesContent,
      cta: translation.ui.textPageCta,
      pageInfo
    };

    return { layoutContent };
  },
  nuxtI18n: {
    locales: ['en']
  },
  head: {}
});
